import { render, staticRenderFns } from "./SponsorsView.vue?vue&type=template&id=7fee12c1&scoped=true&"
import script from "./SponsorsView.vue?vue&type=script&lang=js&"
export * from "./SponsorsView.vue?vue&type=script&lang=js&"
import style0 from "./SponsorsView.vue?vue&type=style&index=0&id=7fee12c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fee12c1",
  null
  
)

export default component.exports